var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"piece-box quick-entry"},[_c('a-row',{attrs:{"gutter":[16,16]}},_vm._l((_vm.list),function(item,i){return _c('a-col',{key:i,attrs:{"span":12}},[_c('div',{staticClass:"quick-entry-item",on:{"click":function($event){return _vm.goHRForm(item.type)}}},[_vm._v(_vm._s(item.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }